module.exports = __webpack_public_path__ + "img/help-icon-active.b63f6779.svg";